import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLive = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23.861 19.143",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M9.695 9.573a2.235 2.235 0 1 0 2.235-2.235 2.235 2.235 0 0 0-2.235 2.235" }),
			/* @__PURE__ */ _jsx("path", { d: "M19.168 18.085a11.174 11.174 0 0 0 0-17.028" }),
			/* @__PURE__ */ _jsx("path", { d: "M16.271 14.681a6.7 6.7 0 0 0 0-10.218" }),
			/* @__PURE__ */ _jsx("path", { d: "M4.693 18.085a11.174 11.174 0 0 1 0-17.028" }),
			/* @__PURE__ */ _jsx("path", { d: "M7.589 14.681a6.7 6.7 0 0 1 0-10.218" })
		]
	})
});
export { SvgIconLive as ReactComponent };
